export default {
  home_select_loan_amount: "选择贷款金额",
  home_max_loan_amount: "最高额度",
  home_payment_amount: "付款金额",
  home_fullAppApplication: "全程app申请，免抵押",
  home_fullH5Application: "全程h5申请，免抵押",
  home_loan_amount: "借款额度",
  home_select_amount: "选择额度",
  home_three_apply: "3分钟内成功申请",
  home_loan_data_more_than: "借款期限超过120天",
  home_time_of_application: "申请时间",
  home_loan_period: "借款周期",
  home_repayment_amount: "还款金额",
  home_interest: "利息",
  home_service_charge: "服务费",
  home_privacy_policy: "我已阅读并同意",
  home_login_privacy_policy: "登录并同意",
  home_login_hello: "你好",
  home_login_welcome: "欢迎来到",
  home_apply_for_loan: "申请贷款",
  home_get_quota_after_application: "申请后获得配额",
  home_minute_review_minutes_funding: "5分钟审核，10分钟拨款",
  home_loan_application: "贷款申请",
  home_contact_us: "联系我们",
  home_contact_information: "联系方式",
  home_phone: "联系电话",
  home_free_consultation: "免费咨询",
  home_address: "地址",
  home_dialog_title: "确认申请",
  home_dialog_msg: "是否确认提交贷款申请？",
  home_authentication: "认证",
  home_fill_information: "填写资料",
  home_toast_success: "申请成功",
  home_toast_withdraw_success: "领取成功",
  home_toast_err_1001: "您已发起过贷款申请，请至订单页查看",
  home_toast_order_view: "已为您生成$1笔订单，请查看",
  home_toast_no_new_order: "当前无新订单生成，请完成在途订单",
  home_toast_fail: "请先阅读并同意",
  home_toast_fail_btn: "隐私政策",
  home_onshow_toast_success: "已发送借款申请，请至订单查看",
  home_cancel_btn: "取消",
  home_confirm_btn: "确定",
  home_transfer: "转账",
  home_credit_card: "信用卡",
  home_immediately_withdraw: "领取金额",
  home_back: "返回",
  home_unit_day: "天",
  home_Overdue_day: "已逾期",
  home_user: "用户",
  home_success_loan: "成功借款",
  home_loan_amount_msg: "收到的金额和退款日期取决于最终结果",
  home_loan_limit: "贷款金额",
  home_click_line_account: "请点击下方链接添加 LINE 账号",
  home_service_fees_include: "服务费包含以下几种费用",
  home_payment_fee: "支付费用",
  home_audit_consultation_fee: "审核咨询费",
  home_handling_fee: "手续费",
  home_successfulLoanToday: "今日已成功放款 XX 人",
  // LINE弹框相关
  line_popup_title: "登入成功!",
  line_popup_content: "为了更快完成您的申请,请立即添加我们的官方LINE,<br>即可享有优先审核与拨款、专人客服即时协助 ✨",
  line_popup_button: "立即加入LINE",
}